
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lrp.twh.nlbe",
      function () {
        return require("private-next-pages/lrp.twh.nlbe.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lrp.twh.nlbe"])
      });
    }
  